import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const COMPANY_ID = "14bdb10d-2d1a-4706-981f-ba9e2981f163";

export interface VacationModeContent {
  enabled?: boolean;
  start_date?: string; // YYYY-MM-DD
  end_date?: string; // YYYY-MM-DD
  message?: string;
  return_note?: string;
}

export function useVacationMode() {
  return useQuery({
    queryKey: ["public", "vacation-mode"],
    queryFn: async () => {
      const { data } = await supabase
        .from("website_content")
        .select("content")
        .eq("company_id", COMPANY_ID)
        .eq("section", "vacation_mode")
        .maybeSingle();
      return (data?.content || {}) as VacationModeContent;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function isVacationActive(v: VacationModeContent | undefined): boolean {
  if (!v?.enabled) return false;
  const today = new Date().toISOString().split("T")[0];
  if (v.start_date && today < v.start_date) return false;
  if (v.end_date && today > v.end_date) return false;
  return true;
}

export function formatVacationRange(v: VacationModeContent): string {
  if (!v.start_date && !v.end_date) return "";
  const fmt = (d: string) => {
    const [y, m, day] = d.split("-").map(Number);
    return new Date(y, m - 1, day).toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };
  if (v.start_date && v.end_date) return `${fmt(v.start_date)}–${fmt(v.end_date)}`;
  if (v.end_date) return `through ${fmt(v.end_date)}`;
  return "";
}